import { z } from 'zod';

export const codReceitaSchema = z
  .string()
  .min(1, 'Código da receita é obrigatório')
  .regex(/^\d+$/, 'Código da receita deve conter apenas números');

export const codPacienteSchema = z
  .string()
  .min(1, 'Código do paciente é obrigatório')
  .regex(/^\d+$/, 'Código do paciente deve conter apenas números');

export const cpfSchema = z
  .string()
  .min(1, 'CPF é obrigatório')
  .regex(/^\d{11}$/, 'CPF deve conter 11 dígitos numéricos')
  .refine(cpf => {
    // Basic CPF validation algorithm
    if (cpf.length !== 11) return false;

    // Check if all digits are the same
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    // Validate first check digit
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rev = 11 - (sum % 11);
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(9))) return false;

    // Validate second check digit
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (sum % 11);
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(10))) return false;

    return true;
  }, 'CPF inválido');

export const farmaciaSchema = z
  .string()
  .min(3, 'Nome da farmácia deve ter pelo menos 3 caracteres')
  .max(100, 'Nome da farmácia deve ter no máximo 100 caracteres')
  .regex(/^[a-zA-Z0-9\s\-.]+$/, 'Nome da farmácia contém caracteres inválidos');

export const receitaValidationSchema = z.object({
  codReceita: codReceitaSchema,
  codPaciente: codPacienteSchema,
  cpfUpdate: cpfSchema,
  origem: farmaciaSchema,
  status: z.literal('Baixada'),
});
